import styled from 'styled-components';

export const SectionContainer = styled.div`
  background-color: #1a1a1a;
  width: 100%;

  @media (max-width: 768px) {
    padding: 40px 0 56px 0;
  }
`;

export const SectionWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 50px;
  max-width: 1369px;
  width: 100%;
  margin: 0 auto;
  padding: 0 20px;

  @media (max-width: 768px) {
    padding: 0;
    max-width: 340px;
    gap: 20px;
  }

  span {
    color: #f16024;
  }

  h1 {
    color: #c3c3c3;
    font-size: 32px;
    font-weight: 275;
    line-height: 40px;

    @media (max-width: 768px) {
      font-size: 18px;
      line-height: 32px;
    }
  }
`;

export const StyledHr = styled.hr`
  flex: 1;
  border: 1px solid #c3c3c3;
  margin: 0 20px;

  @media (max-width: 768px) {
    margin: 0;
  }
`;

export const ContentWrapper = styled.div`
  max-width: 1180px;
  width: 100%;
  margin: 120px auto 50px;

  p {
    text-align: left;
    font-size: 18px;
    font-weight: 300;
    line-height: 24px;
    color: #c3c3c3;

    span {
      color: #f16024;
    }

    @media (max-width: 768px) {
      margin: 24px 0 0;
    }
  }

  @media (max-width: 768px) {
    width: 100%;
    max-width: 340px;
    margin: 0 auto;
  }
`;

export const TextBox1 = styled.div`
  display: flex;
  justify-content: center;
  gap: 50px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 10px;
    align-items: center; /* Alinha itens ao centro */
  }

  span {
    color: #f16024;
  }
`;

export const TextBox2 = styled.div`
  line-height: 16px;
  color: #c3c3c3;
  padding: 40px;
  margin-top: 48px;

  &:hover {
    background-color: #171717;
  }

  @media (max-width: 768px) {
    padding: 0;
    margin-top: 0;

    &:hover {
      background-color: transparent;
    }
  }

  ul {
    margin-left: 20px;
    padding: 0;
    list-style-position: inside;

    @media (max-width: 768px) {
      padding-right: 0;
    }
  }

  li {
    font-family: 'Open Sans';
    font-size: 16px;
    font-weight: 300;
    line-height: 24px;
    margin-bottom: 10px;
    padding: 0;
  }

  p {
    font-size: 24px;
    font-weight: 300;
    line-height: 32px;

    margin-bottom: 20px;
  }
`;
